import Vue from 'vue';
import VueRouter from 'vue-router';

import '@/plugins/languagen';

import { otmizacao } from '../../../package.json';

// PROPRIEDADES

let routes = null;
let router = null;
let base   = '/';

init();

function init() {

    if(otmizacao.multilinguagem){
        const lang = Vue.prototype.$lang_.getLang().title;
        base = lang + '/';

        switch(lang){
            case 'pt':
                routes = require('@/plugins/router/pt.js').default;
                break;
            case 'es':
                routes = require('@/plugins/router/es.js').default;
                break;
            case 'en':
                routes = require('@/plugins/router/en.js').default;
                break;
        }
    } else {
        routes = require('@/plugins/router/pt.js').default;
    }

    exit();
}

function exit() {

    const config = {
        base: base, 
        mode: 'history',
        routes
    }

    router = new VueRouter(config)

    router.beforeEach((to, from, next) => {
        
        next();

        document.title = to.meta.title;
        
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })

    })

    Vue.use(VueRouter)

}


export default router
